import { render, staticRenderFns } from "./shiftItem.vue?vue&type=template&id=962e76fc&scoped=true&"
import script from "./shiftItem.vue?vue&type=script&lang=js&"
export * from "./shiftItem.vue?vue&type=script&lang=js&"
import style0 from "./shiftItem.vue?vue&type=style&index=0&id=962e76fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962e76fc",
  null
  
)

export default component.exports